export const getAddressText = ({ address, countryName = '', twoLines = false, inline = false, showAccess = true }) => {
    if (!address) {
        return '';
    }

    let addressText = '';
    if (address.Name) {
        addressText += `<strong>${address.Name}</strong>`;
        addressText += '<br />';
    }
    if (address.Street) {
        addressText += address.Street + ', ';
    }
    if (address.Street && twoLines) {
        addressText += '<br />';
    }

    // this part can be formatted differently depending on the country
    let localLine = '';
    switch (address.Country) {
        case 'US':
            if (address.City) {
                localLine += `${address.City}, `;
            }
            if (address.State) {
                if (localLine.length > 0) {
                    localLine += ` ${address.State}`;
                } else {
                    localLine += address.State;
                }
            }
            if (address.Zip) {
                if (localLine.length > 0) {
                    localLine += ` ${address.Zip}`;
                } else {
                    localLine += address.Zip;
                }
            }
            if (address.County) {
                if (localLine.length > 0) {
                    localLine += `<br/>${address.County}`;
                } else {
                    localLine += address.County;
                }
            }
            if (countryName) {
                if (localLine.length > 0) {
                    localLine += `<br/>${countryName}`;
                } else {
                    localLine += countryName;
                }
            }
            break;
        case 'IT':
            if (address.Zip) {
                localLine += ` ${address.Zip},`;
            }
            if (address.City) {
                if (localLine.length > 0) {
                    localLine += ` ${address.City}`;
                } else {
                    localLine += address.City;
                }
            }
            if (address.County) {
                if (localLine.length > 0) {
                    localLine += ` ${address.County}`;
                } else {
                    localLine += address.County;
                }
            }
            if (address.State) {
                if (localLine.length > 0) {
                    localLine += `<br/>${address.State}`;
                } else {
                    localLine += address.State;
                }
            }
            if (countryName) {
                if (localLine.length > 0) {
                    localLine += `<br/>${countryName}`;
                } else {
                    localLine += countryName;
                }
            }
            break;
        case 'UK':
            if (address.City) {
                localLine += address.City;
            }
            if (address.Zip) {
                if (localLine.length > 0) {
                    localLine += ` ${address.Zip}`;
                } else {
                    localLine += address.Zip;
                }
            }
            if (address.County) {
                if (localLine.length > 0) {
                    localLine += `<br/>${address.County}`;
                } else {
                    localLine += address.County;
                }
            }
            if (address.State) {
                if (localLine.length > 0) {
                    localLine += `<br/>${address.State}`;
                } else {
                    localLine += address.State;
                }
            }
            if (countryName) {
                if (localLine.length > 0) {
                    localLine += `<br/>${countryName}`;
                } else {
                    localLine += countryName;
                }
            }
            break;
        // case "FR":
        // case "DE":
        default:
            if (address.Zip) {
                localLine += `${address.Zip},`;
            }
            if (address.City) {
                if (localLine.length > 0) {
                    localLine += ` ${address.City}`;
                } else {
                    localLine += address.City;
                }
            }
            if (address.County) {
                if (localLine.length > 0) {
                    localLine += `<br/>${address.County}`;
                } else {
                    localLine += address.County;
                }
            }
            if (address.State) {
                if (localLine.length > 0) {
                    localLine += `<br/>${address.State}`;
                } else {
                    localLine += address.State;
                }
            }
            if (countryName) {
                if (localLine.length > 0) {
                    localLine += `<br/>${countryName}`;
                } else {
                    localLine += countryName;
                }
            }
            break;
    }
    addressText += localLine;

    if (showAccess && address.Access) {
        if (addressText.length > 0) {
            addressText += '<br />';
        }
        addressText += `Access: ${address.Access}`;
    }

    if (!inline) {
        return addressText;
    }

    const accessLineMatch = addressText.match(/<br\s*\/?>\s*Access:/i);
    let mainText = addressText;
    let accessText = '';

    if (accessLineMatch) {
        const accessIndex = addressText.indexOf(accessLineMatch[0]);
        mainText = addressText.slice(0, accessIndex);
        accessText = addressText.slice(accessIndex).replace(/<br\s*\/?>\s*/i, '');
    }

    const normalizedMainText = mainText
        .replace(/<br\s*\/?>/gi, ' · ')
        .replace(/\s{2,}/g, ' ')
        .replace(/\s+,/g, ',')
        .replace(/,\s*·/g, ' ·')
        .trim();

    if (!accessText) {
        return normalizedMainText;
    }

    if (!normalizedMainText) {
        return accessText.trim();
    }

    return `${normalizedMainText}<br />${accessText.trim()}`;
};

export const getCompactAddressText = ({ address, countryName = '', showAccess = true }) => {
    if (!address) {
        return '';
    }

    let addressText = '';
    if (address.Name) {
        addressText += `<strong>c/o ${address.Name}</strong>`;
        addressText += '<br />';
    }
    if (address.Street) {
        addressText += address.Street + ',';
    }

    // this part can be formatted differently depending on the country
    let localLine = '';
    switch (address.Country) {
        case 'US':
            if (address.City) {
                localLine += `${address.City}, `;
            }
            if (address.State) {
                if (localLine.length > 0) {
                    localLine += ` ${address.State}`;
                } else {
                    localLine += address.State;
                }
            }
            if (address.Zip) {
                if (localLine.length > 0) {
                    localLine += ` ${address.Zip}`;
                } else {
                    localLine += address.Zip;
                }
            }
            if (countryName) {
                if (localLine.length > 0) {
                    localLine += ` ${address.Country}`;
                } else {
                    localLine += address.Country;
                }
            }
            break;
        case 'IT':
            if (address.Zip) {
                localLine += ` ${address.Zip},`;
            }
            if (address.City) {
                if (localLine.length > 0) {
                    localLine += ` ${address.City}`;
                } else {
                    localLine += address.City;
                }
            }
            if (address.County) {
                if (localLine.length > 0) {
                    localLine += ` ${address.County}`;
                } else {
                    localLine += address.County;
                }
            }
            if (countryName) {
                if (localLine.length > 0) {
                    localLine += ` ${address.Country}`;
                } else {
                    localLine += address.Country;
                }
            }
            break;
        case 'UK':
            if (address.City) {
                localLine += address.City;
            }
            if (address.Zip) {
                if (localLine.length > 0) {
                    localLine += ` ${address.Zip}`;
                } else {
                    localLine += address.Zip;
                }
            }
            if (countryName) {
                if (localLine.length > 0) {
                    localLine += ` ${address.Country}`;
                } else {
                    localLine += address.Country;
                }
            }
            break;
        // case "FR":
        // case "DE":
        default:
            if (address.Zip) {
                localLine += `${address.Zip},`;
            }
            if (address.City) {
                if (localLine.length > 0) {
                    localLine += ` ${address.City}`;
                } else {
                    localLine += address.City;
                }
            }
            if (countryName) {
                if (localLine.length > 0) {
                    localLine += ` ${address.Country}`;
                } else {
                    localLine += address.Country;
                }
            }
            break;
    }
    addressText += localLine;

    if (showAccess && address.Access) {
        if (addressText.length > 0) {
            addressText += ' - ';
        }
        addressText += `Access: ${address.Access}`;
    }
    return addressText;
};
